export const APP_BASE_DOMAIN = process.env.REACT_APP_WEB_BASE_DOMAIN;

export const APP_BRAND_NAME = 'Online Playing Card Game';

export const META_TITLE = 'Join The Room To Play With Me!';
export const META_DESCRIPTION = 'I\'d like to invite you to join this game. Click the link below.';
export const META_IMAGE_PATH = '/assets/app-icon.png';

export const STO_ROOM_ID = 'rId';
export const STO_PLAYER_ID = 'pId';
export const STO_PLAYER_NAME = 'pName';
export const STO_VOLUME_STATUS = 'volume';
export const STO_PLAYER_EFFECT = 'playerEffect';
export const STO_AC_TOKEN = 'acToken';
export const STO_ACCESS_TOKEN = 'accessToken';
export const STO_REFRESH_TOKEN = 'refreshToken';
export const STO_GUEST_SESSION = 'guestSession';

export const FACEBOOK_PAGE_ID = '537573886105589';
export const FACEBOOK_MESSENGER_URL = `https://m.me/${FACEBOOK_PAGE_ID}`;
export const FACEBOOK_WEB_SHARE_URL = 'https://www.facebook.com/share/1BxsManzJ4/?mibextid=wwXIfr';

export const VOICE_AGORA_APP_ID = '3bb8adb1661b406fad0b8454abd905be';

export const GAME_STATE = {
    initialHosted: 0,
    playing: 1,
    winDeclared: 2,
    readyForNextMatch: 3,
}

export const PLAYER_STATE = {
    ready: 0,
    turnPick : 1,
    pickedDeckCard: 2,
    pickedDiscardedCard: 3,
    waitingTurn: 4,
    declaredWin: 5,
    waitWinCardsShow: 6,
    notReady: 7,
    leftRoom: 8,
    spectating: 9,
    dropped: 10,
}
